import React from 'react'
import { ConfigProvider, message as $message } from 'antd'
import { StyleSheetManager } from 'styled-components'
import zhCN from 'antd/es/locale/zh_CN'
import { getRootDom } from '@/utils/utils'
import { isSingleAppDomain } from '@/utils/singleApp'
import { captureException } from '@/utils/track'

import { queryDomainConfig } from '@/services/singleApp/settings'
import { gylFrameReady } from '@/modules/globals/components/frame/utils/index'

import { getCoId, getUid, checkTokenIsReady } from '@/utils/token'
import { checkHostInstanceIsReady } from '@/utils/hostInstance'
import { resolveRender } from '@/utils/appRender'

const notMasterTerminal = [window.PROJECT_CONFIG.towerTerminalName, window.PROJECT_CONFIG.darenTerminalName]

/**
 * 全局配置准备，阻塞应用渲染
 */
const waitGlobalConfigReady = async () => {
    console.time('waitGlobalConfigReady')
    // 需要等待token、hostInstance初始化完成
    await Promise.all([checkHostInstanceIsReady(), checkTokenIsReady()])
    console.timeEnd('waitGlobalConfigReady')

    // 塔内内嵌在erp 默认供应商身份
    if (notMasterTerminal.includes(PROJECT_CONFIG.terminalName) && !window.__POWERED_BY_GYL_FRAME__) {
        window.MASTER_IS_CHANNEL = false
        window.MASTER_IS_SUPPLIER = window.IS_SUPPLY = true
        window.MASTER_PROJECT_CONFIG = PROJECT_CONFIG
    }
    // 塔内内嵌在erp 默认供应商身份
    if (notMasterTerminal.includes(PROJECT_CONFIG.terminalName) && window.PROJECT_CONFIG.mode === 'dev') {
        window.MASTER_IS_CHANNEL = false
        window.MASTER_IS_SUPPLIER = window.IS_SUPPLY = true
        window.MASTER_PROJECT_CONFIG = PROJECT_CONFIG
    }

    // 塔内内嵌在供应链的时候，gylFrameReady 这个方法拿到父级的 MASTER_PROJECT_CONFIG
    if (notMasterTerminal.includes(PROJECT_CONFIG.terminalName) && window.__POWERED_BY_GYL_FRAME__) {
        await gylFrameReady()
    }

    //  三层嵌套 塔内内嵌在数据菜单
    //  供应链或者erp 的数据菜单中内嵌的数据中内嵌了 售后，这个时候 渠道侧调用供应侧get userinfo 接口，初始化了供应侧身份
    if (PROJECT_CONFIG.terminalName === 'TOWER' && window.__POWERED_BY_AFTER_WARN_FRAME__) {
        window.MASTER_IS_CHANNEL = true
        window.MASTER_IS_SUPPLIER = window.IS_SUPPLY = false
        window.MASTER_PROJECT_CONFIG = PROJECT_CONFIG
    }

    // 双奇电商
    if (PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.sqmallTerminalName) {
        window.MASTER_IS_CHANNEL = true
        window.MASTER_IS_SUPPLIER = window.IS_SUPPLY = false
        window.MASTER_PROJECT_CONFIG = PROJECT_CONFIG
        window.TERMINANAME_IS_SQMALL = true
        window.MASTER_IS_DZL_CSS = true
    }
    // 独立站，默认按照分销商身份去看
    if (PROJECT_CONFIG.terminalNameSecond === PROJECT_CONFIG.dlzTerminalName) {
        window.MASTER_IS_CHANNEL = true
        window.MASTER_IS_SUPPLIER = window.IS_SUPPLY = false
        window.MASTER_PROJECT_CONFIG = PROJECT_CONFIG
        window.TERMINANAME_IS_DLZ = true
        window.MASTER_IS_DZL_CSS = true
    }

    // 如果是独立应用版本则查询当前域名的配置
    if (isSingleAppDomain) {
        try {
            const { success, message, data } = await queryDomainConfig()

            if (success) {
                window.__SINGLE_APP_SETTINGS = data
            } else {
                $message.error(message)

                captureException('加载应用配置失败', {
                    anchor: 'queryDomainConfig',
                    extra: {
                        message
                    }
                })
            }
        } catch (e) {
            console.error('catchError', e)
            captureException('加载应用配置失败', {
                anchor: 'queryDomainConfig',
                extra: e
            })
        }
    }
}

export async function render(oldRender) {
    await waitGlobalConfigReady()

    oldRender()

    resolveRender()
}

export function rootContainer(children) {
    if (PROJECT_CONFIG.terminalName === 'OP') {
        document.querySelector('#root').style.overflowY = 'auto'
        return <ConfigProvider locale={zhCN}>{children}</ConfigProvider>
    }

    if (PROJECT_CONFIG.terminalName === 'TOWER') {
        document.querySelector('#root').style.height = '100%'
    }
    return (
        <ConfigProvider locale={zhCN} getPopupContainer={() => getRootDom()}>
            <StyleSheetManager disableCSSOMInjection>
                <div id="real-root">{children}</div>
            </StyleSheetManager>
        </ConfigProvider>
    )
}

/* ------------  webbox ------------ */
function loadWebbox() {
    try {
        const mode = PROJECT_CONFIG.sentryMode || PROJECT_CONFIG.mode || 'dev'
        // uat 环境不开启, 非渠道侧,供应侧不开启
        // eslint-disable-next-line
        if (
            ![PROJECT_CONFIG.supplierTerminalName, PROJECT_CONFIG.channelTerminalName].includes(
                PROJECT_CONFIG.terminalNameSecond
            ) ||
            mode === 'uat'
        ) {
            return
        }

        document.addEventListener('DOMContentLoaded', () => {
            const uid = getUid()
            const coid = getCoId()

            if (!uid || !coid) {
                return
            }

            const loadConfigName = 'gyl-home'
            const _ENV = {
                isTest: mode === 'test',
                isPre: mode === 'pre',
                isProd: mode === 'prod'
            }
            const userPortrait = new window.UserPortrait({ uid: uid, prefix: 'gyl-menu', expired: 14 })
            const menuKeys = Object.keys(userPortrait.getRecords() ?? {})
            if (typeof userPortrait?.setRecords === 'function') {
                window.jmx.on('common.gyl.menuOpen', ({ key }) => {
                    userPortrait.setRecords(key)
                })
            }

            window.webboxLoad.loadConfigJS({
                envObj: _ENV,
                uid,
                coid,
                loadConfigName,
                userPortrait: { menuKeys }
            })
        })
    } catch (e) {
        console.error('webbox', e)
    }
}
loadWebbox()
